import { Observable } from 'rxjs';
import { IComment, ITaskInfo, IUserShort } from '@valhalla/data/entities';

export abstract class CommentsDataHttpService {
	abstract getCommentViewers(criteria: IGetCommentViewersCriteria): Observable<IGetCommentViewersResult>;

	abstract markCommentAsQuestion(criteria: IMarkCommentAsQuestionCriteria): Observable<any>;

	abstract addCommentToFavorite(criteria: ICommentFavoriteCriteria): Observable<any>;

	abstract removeCommentToFavorite(criteria: ICommentFavoriteCriteria): Observable<any>;

	abstract markCommentsAsRead(...commentIds: number[]): Observable<any>;

	abstract markCommentAsUnread(commentId: number): Observable<any>;

	abstract markCommentsAsAnswered(commentId: number): Observable<any>;

	abstract markCommentsAsNotMyQuestion(commentId: number): Observable<any>;

	abstract getCommentsSlice(criteria: IGetCommentsOffsetCriteria): Observable<IGetCommentsOffsetResult>;

	abstract getComment(commentId: number): Observable<Partial<IComment>>;

	abstract delete(...ids: number[]): Observable<any>;

	abstract edit(model: IEditCommentsCriteria): Observable<any>;

	abstract getPreviousTaskText(commentId: number): Observable<IGetPreviousTaskTextResult>;
}

export interface IGetPreviousTaskTextResult {
	newTaskText: string;
	oldTaskText: string;
}

export interface IEditCommentsCriteria {
	commentId: number;
	text: string;
}

export interface IGetCommentViewersCriteria {
	commentId: number;
	searchInArchiveIfNotFound?: boolean;
}

export interface IGetCommentViewersResult {
	users: IGetCommentViewerResult[];
}

export interface IGetCommentViewerResult {
	user: Partial<IUserShort>;
	seenAt: string;
}

export interface IMarkCommentAsQuestionCriteria {
	commentIds: number[];
}

export interface ICommentFavoriteCriteria {
	commentId: number;
	color?: string;
}

export interface IGetCommentsOffsetCriteria {
	commentId?: number;
	limitBefore?: number;
	limitAfter?: number;
	taskInfo?: boolean;
	taskId?: number;
	selectedTypes?: number[];
	/**включения/выключения фильтра комментариев по всем типам сыобытий */
	useFeedFilterSettings?: boolean;
	/**из связанных */
	forTaskTree?: boolean;
	/**из подзадач */
	forLinkedTasks?: boolean;
	searchString?: string;
	searchType?: string;
}

export interface IGetCommentsOffsetResult extends Omit<Partial<ITaskInfo>, 'comments'> {
	comments: Array<Partial<IComment>>;
	tasks?: Partial<ITaskInfo>[];
}
